import get_drawer_links from "../../../utils/drawerLinks";

const state = {
    loggedInUser: null
};
const getters = {
    currentUser() {
        return state.loggedInUser;
    },
    userLinks() {
        var user = JSON.parse( localStorage.getItem("user"));
        if (user) {
            console.log('get_drawer_links');
            return get_drawer_links(user.user_role);
        }
        return [];
    },
};
const actions = {
    authUser(context, userData) {
        context.commit("authUser", userData);
    }
};
const mutations = {
    authUser(state, userData) {
        // axios.defaults.headers.common.Authorization = `Bearer ${userData.auth_token}`;
        state.loggedInUser = userData.user;
    }
};
export default {
    state,
    actions,
    mutations,
    getters
};
